'use client';

import { Media } from '@/lib/payload/types';
import PayloadImage from '@/ui/PayloadImage';
import { motion } from 'motion/react';
import styles from './ProjectCard.module.scss';

export type ProjectBannerProps = { banner?: Media | string | number };

const ProjectBanner: React.FC<ProjectBannerProps> = ({ banner }) => {
  return (
    <motion.div
      className={styles.banner}
      initial="rest"
      whileHover="hover"
      variants={{ rest: {}, hover: {} }}
    >
      <motion.div
        className={styles.bannerImage}
        variants={{ rest: { y: '10%', width: '82%' }, hover: { y: '0%', width: '85%' } }}
        transition={{ duration: 0.3, bounce: 0, ease: 'easeInOut' }}
      >
        <PayloadImage
          image={banner}
          width={600}
          height={300}
          placeholder="blur"
          blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mPcfe7cfwAH+wNY8+pIGQAAAABJRU5ErkJggg=="
        />
      </motion.div>
    </motion.div>
  );
};

export default ProjectBanner;
